import React, { useEffect, useState } from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import LinkAdAccount from './LinkAdAccount';
import LinkAdAccountAnimation from './LinkAdAccountAnimation';
import LoginMedia from './LoginMedia';
import ChooseMedia from './ChooseMedia';

import {
  ModalWrapperSimple,
  ModalWrapperNormal
} from '../customComponent/box';
import ModalHeader from '../pop/ModalHeader';
import ModalFooter from '../pop/ModalFooter';

import * as adAccountConstants from './constants';

const content = {
  [adAccountConstants.AD_MEDIA]: {
    title: '選擇廣告帳號',
    submit: '授權',
    alert: false
  },
  [adAccountConstants.ADD_SHARE_AD_ACCOUNT]: {
    title: '分享廣告帳號',
    submit: '分享',
    alert: false
  },
  [adAccountConstants.EDIT_SHARE_AD_ACCOUNT]: {
    title: '編輯分享對象',
    submit: '儲存',
    alert: false
  },
  [adAccountConstants.LINK_OFF_AD_ACCOUNT]: {
    title: '移除授權',
    submit: '移除',
    alert: true
  },
  [adAccountConstants.LINK_AD_ACCOUNT]: {
    title: '授權廣告帳號',
    submit: '授權',
    alert: false
  },
  [adAccountConstants.LINK_AD_ACCOUNT_GOOGLE]: {
    title: '授權 Google 廣告帳號',
    submit: '授權',
    alert: false
  },
  [adAccountConstants.LINK_AD_ACCOUNT_LINE]: {
    title: '授權 LINE 廣告帳號',
    submit: '授權',
    alert: false
  },
  [adAccountConstants.LINK_AD_ACCOUNT_TABOOLA]: {
    title: '授權 Taboola 廣告帳號',
    submit: '授權',
    alert: false
  }
}

const AdAccountModal = (props) => {
  const {
    modalType,
    setModalType,
    modalData,
    mediaData,
    handleSubmit,
    handleCloseModal,
    chooseMedia,
    googleAccountData,
    handleLoginMedia
  } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const [triggerCheckFlow, setTriggerCheckFlow] = useState(false);

  useEffect(() => {
    setModalOpen(true);
  }, [modalType])


  const handleClose = () => {
    setModalOpen(false);
    handleCloseModal();
  }

  const handleLinkAdAccount = (data) => {
    handleSubmit(data);
    setTriggerCheckFlow(false);
  }

  const triggerSubmit = () => {
    setTriggerCheckFlow(true);
  }

  if (modalType === adAccountConstants.LOGIN_MEDIA || modalType === adAccountConstants.LINK_AD_ACCOUNT_ANIMATION || modalType === adAccountConstants.CHOOSE_MEDIA) {

    return (
      <Modal open={modalOpen}>
        <ModalWrapperSimple>
          {
            modalType === adAccountConstants.CHOOSE_MEDIA &&
            <ChooseMedia
              handleSubmit={handleSubmit}
              googleAccountData={googleAccountData}
              handleLoginMedia={handleLoginMedia}
            />
          }
          {
            modalType === adAccountConstants.LOGIN_MEDIA &&
            <LoginMedia
              handleClose={handleClose}
              handleSubmit={handleSubmit}
              chooseMedia={chooseMedia}
              mediaData={mediaData}
            />
          }
          {
            modalType === adAccountConstants.LINK_AD_ACCOUNT_ANIMATION &&
            <LinkAdAccountAnimation
              currentData={modalData}
              handleClose={handleClose}
              handleSubmit={handleSubmit}
            />
          }
        </ModalWrapperSimple>
      </Modal>
    )
  }

  return (
    <>
      {
        modalType &&
        <Modal
          open={modalOpen}
        >
          <ModalWrapperNormal
            sx={{
              maxWidth: '600px',
            }}
          >
            <ModalHeader
              title={content[modalType].title}
              handleClose={handleClose}
            />

            <Box
              sx={{
                overflow: 'auto',
                maxHeight: '50vh',
                padding: '32px 16px',
              }}
            >
              {
                modalType === adAccountConstants.LINK_AD_ACCOUNT &&
                <LinkAdAccount
                  currentData={modalData}
                  triggerSubmit={triggerCheckFlow}
                  handleLinkAdAccount={handleLinkAdAccount}
                />
              }
              {
                modalType === adAccountConstants.LINK_AD_ACCOUNT_GOOGLE &&
                <LinkAdAccount
                  currentData={modalData}
                  triggerSubmit={triggerCheckFlow}
                  handleLinkAdAccount={handleLinkAdAccount}
                />
              }
              {
                modalType === adAccountConstants.LINK_AD_ACCOUNT_LINE &&
                <LinkAdAccount
                  currentData={modalData}
                  triggerSubmit={triggerCheckFlow}
                  handleLinkAdAccount={handleLinkAdAccount}
                />
              }
              {
                modalType === adAccountConstants.LINK_AD_ACCOUNT_TABOOLA &&
                <LinkAdAccount
                  currentData={modalData}
                  triggerSubmit={triggerCheckFlow}
                  handleLinkAdAccount={handleLinkAdAccount}
                />
              }
            </Box>

            <ModalFooter
              // processing={}
              checkBottonContent={content[modalType].submit}
              type={content[modalType].alert ? 'delete' : ''}
              handelCancel={handleClose}
              handleSubmit={triggerSubmit}
            />
          </ModalWrapperNormal>

        </Modal>
      }
    </>
  )
}

export default AdAccountModal;